export function buildShortUrl(origin: string, alias: string): string {
  const o = origin.replace(/\/+$/, '');
  return `${o}/${alias}`;
}

export function originForLinks(): string {
  return window.location.origin;
}
